import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const adminModule: ForqModuleManifest = {
  id: 'admin',
  name: 'Administration',
  description: 'Benutzer, Rollen, Nummernkreise, Stammdatenschemas und Audit verwalten',
  version: '0.2.0',
  route: '/admin',
  category: 'system',
  status: 'development',
  requiredPermissions: ['admin.view'],
  features: [
    'admin.overview',
    'admin.company',
    'admin.documents',
    'admin.users',
    'admin.access-requests',
    'admin.announcements',
    'admin.bugs',
    'admin.roles',
    'admin.numbering',
    'admin.machine-types',
    'admin.masters',
    'admin.audit',
  ],
  navigation: [
    {
      id: 'admin.home', label: 'Administration', route: '/admin',
      placement: 'primary', order: 900, icon: 'admin',
    },
    {
      id: 'admin.launcher', label: 'Administration', route: '/admin',
      placement: 'launcher', order: 900, icon: 'admin',
    },
  ],
};

export const adminFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'admin.overview', moduleId: 'admin', name: 'Übersicht',
    description: 'System- und Mandantenstatus', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.view'], uiSlots: ['admin.main'], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.company', moduleId: 'admin', name: 'Grundkonfiguration',
    description: 'Firma, Bank, Briefbogen, Belegvorgaben und DATEV-Mandat je Mandant', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.view'], uiSlots: ['admin.main'], emits: ['admin.company.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.documents', moduleId: 'admin', name: 'Prüflisten & Dokumente',
    description: 'Zusatzdokumente/Prüflisten (UVV, Protokolle) je Mandant, die beim Werkstattauftrag angeboten werden', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.view'], uiSlots: ['admin.main'], emits: ['admin.documents.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.users', moduleId: 'admin', name: 'Benutzer',
    description: 'Benutzer und Mandantenzuordnungen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.users.view'], uiSlots: ['admin.main'], emits: ['admin.user.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.access-requests', moduleId: 'admin', name: 'Zugangsanfragen',
    description: 'Anfragen aus dem öffentlichen Login-Formular freigeben oder ablehnen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.users.view'], uiSlots: ['admin.main'], emits: ['admin.access-request.decided'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.announcements', moduleId: 'admin', name: 'Systemmeldungen',
    description: 'Das Fenster, das den Benutzern beim Start von FORQ angezeigt wird', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.view'], uiSlots: ['admin.main'], emits: ['admin.announcement.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.bugs', moduleId: 'admin', name: 'Fehlermeldungen',
    description: 'Rückmeldungen der Kollegen aus der laufenden Anwendung bearbeiten', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.bugs.view'], uiSlots: ['admin.main'], emits: ['admin.bug.status-changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.roles', moduleId: 'admin', name: 'Rollen & Rechte',
    description: 'Rollen und Berechtigungen je Mandant', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.roles.view'], uiSlots: ['admin.main'], emits: ['admin.role.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.numbering', moduleId: 'admin', name: 'Nummernkreise',
    description: 'Mandanten- und jahresabhängige Nummernkreise', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.numbering.view'], uiSlots: ['admin.main'], emits: ['admin.numbering.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.machine-types', moduleId: 'admin', name: 'Maschinentypen',
    description: 'Dynamische technische Felder je Maschinentyp verwalten', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.types.manage'], uiSlots: ['admin.main'], emits: ['machine.type.changed'], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.masters', moduleId: 'admin', name: 'Kostenstellen & Warengruppen',
    description: 'Kostenstellen (je Beleg) und Warengruppen (je Ware/Leistung) pflegen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.view'], uiSlots: ['admin.main'], emits: [], listensTo: ['tenant.changed'],
  },
  {
    id: 'admin.audit', moduleId: 'admin', name: 'Audit',
    description: 'Nachvollziehbare Systemänderungen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['admin.audit.view'], uiSlots: ['admin.aside'], emits: [], listensTo: ['tenant.changed'],
  },
];
